import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CasosService } from './casos.service';
import { CasosTranslations, casosTranslations } from './translations-casos';
import { getCurrentLanguage } from '../core/helpers/utils';
import { formatDateString, formatDateStringWithTime } from '../core/helpers/utils';
import { AuthenticationService } from '../core/service/auth.service';

// services
import { EventService } from 'src/app/core/service/event.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// types
import { SortEvent } from 'src/app/shared/advanced-table/sortable.directive';
import { Column } from 'src/app/shared/advanced-table/advanced-table.component';
import { Caso } from './casos.model';
import { User } from '../core/models/auth.models';

@Component({
  selector: 'app-list-casos',
  templateUrl: './list-casos.component.html',
  styleUrls: ['./list-casos.component.scss']
})
export class ListCasosComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private router: Router,
    private elRef: ElementRef,
    private casosService: CasosService,
    private authService: AuthenticationService
  ) { }

  records: Caso[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];

  // Botón de acción de la tabla
  currentLanguage: string = getCurrentLanguage()
  buttonTitle: string = '';
  buttonTitle2: string = '';
  buttonLink: string = 'casos/new';

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Animación de loading
  loading: boolean = false;

  // Para controlar las búsquedas
  allDatasearch: Caso[] = []
  filteredRecords: Caso[] = [];
  columnFilters: { [key: string]: string } = {};
  globalSearchTerm: string = '';
  currentSort: SortEvent | null = null;

  usuario: User = {};

  disableNoAdmin: boolean = false;

  ngAfterViewInit(): void { }

  ngOnInit(): void {
    //Le doy valor al botón
    const currentTranslations = casosTranslations[this.currentLanguage].TABLE;
    this.buttonTitle = currentTranslations.BUTTON;

    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.CASOS,
        breadCrumbItems: [{ label: currentTranslations.CASOS, path: '.', active: true }]
      }
    );

    this.authService.currentUser().subscribe(user => {
      // En este punto, user tiene toda la información actualizada, incluido nivel_acceso
      //console.log("TOPNAV USER->", user)
      if (user?.nivel_acceso) {

        // Si no soy admin desactivo opciones para el caso. Comento para dejar pasar a los usuarios a los casos cerrados
        /*
        if (user.nivel_acceso != "ADMIN") {
          this.disableNoAdmin = true;
        }
          */

        // Si no soy admin desactivo el botón de crear caso
        if (user.nivel_acceso != "ADMIN") {
          this.buttonLink = '';
        }

        /* Desactivo el botón de descarga de casos
        // Si soy ADMIN le doy título al botón de Descargar casos. En AdvancedTable este botón tiene un *ngif=buttonTitle2
        if (user.nivel_acceso === "ADMIN") {          
          this.buttonTitle2 = currentTranslations.BUTTON2;
        }
          */

        this.usuario = user;

        this._fetchData();
      }
    });


  }

  /**
   * fetches table records
   */
  _fetchData(): void {
    if (this.usuario.id) {
      // Usuario ADMIN
      if (this.usuario.nivel_acceso === "ADMIN") {
        this.casosService.getCasos().subscribe((res) => {
          //console.log("getCasosUsuario", res, this.usuario.id)
          this.records = res.sort((a, b) => b.numero_expediente.localeCompare(a.numero_expediente));
          this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
          this.initTableCofig();
          this.applyFilters();
          this.loaded = true;
        },
          (error: string) => {
            this.error = error;
            this.loaded = false;
          });
      }
      else {
        // USUARIO REPRESENTANTO O ARBITRO
        this.casosService.getCasosUsuario(this.usuario.id).subscribe((res) => {
          //console.log("getCasosUsuario", res, this.usuario.id)
          this.records = res.sort((a, b) => b.numero_expediente.localeCompare(a.numero_expediente));
          this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
          this.initTableCofig();
          this.applyFilters();
          this.loaded = true;
        },
          (error: string) => {
            this.error = error;
            this.loaded = false;
          });
      }
    }


  }

  /**
  * initialize advanced table columns
  */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage();
    const currentTranslations = casosTranslations[currentLanguage].TABLE;

    this.columns = [
      {
        name: 'numero_expediente',
        label: currentTranslations.NUMERO_EXPEDIENTE,
        formatter: (record: Caso) => record.numero_expediente,
        width: this.usuario.nivel_acceso === "ADMIN" ? 200 : 400,
      },
      {
        name: 'estado',
        label: currentTranslations.ESTADO,
        formatter: (record: Caso) => record.estado ? record.estado.replace(/_/g, ' ') : '',
        width: 20,
      },
      {
        name: 'fecha_solicitud',
        label: currentTranslations.FECHA_SOLICITUD,
        formatter: (record: Caso) => formatDateString(record.fecha_solicitud ?? '', currentLanguage),
        width: 100,
      },
      {
        name: 'tribunal',
        label: currentTranslations.TRIBUNAL,
        formatter: (record: Caso) => record['tribunal'],
        width: 20,
        sort: false,
      }
    ];

    // Agrega las columnas adicionales si el usuario es ADMIN
    if (this.usuario.nivel_acceso === "ADMIN") {
      this.columns.push(
        {
          name: 'ultimoHitoDescripcion',
          label: currentTranslations.ULTIMO_HITO,
          formatter: (record: Caso) => record.ultimoHitoDescripcion,
          width: 200,
          sort: false,
        }
      );
    }

    // Siempre agrega la columna de acciones
    this.columns.push({
      name: 'accionesCasos',
      label: currentTranslations.ACTIONS,
      formatter: (record: Caso) => null, // No es necesario enviar nada a advanced table porque la columna acciones está personalizada en el componente
      width: 30,
      sort: false,
    });

    this.initColumnFilters();
  }

  // compares two cell values
  compare(v1: string | number | null, v2: string | number | null, isAscending: boolean): number {
    // Determinar el valor predeterminado basado en el orden
    const defaultValue = typeof v1 === 'number' || typeof v2 === 'number' ? 0 : (isAscending ? '9999' : '0000');

    const value1 = v1 ?? defaultValue;
    const value2 = v2 ?? defaultValue;

    if (typeof value1 === 'number' && typeof value2 === 'number') {
      return value1 - value2;
    }

    if (typeof value1 === 'string' && typeof value2 === 'string') {
      return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
    }

    const strValue1 = value1.toString();
    const strValue2 = value2.toString();
    return strValue1 < strValue2 ? -1 : strValue1 > strValue2 ? 1 : 0;
  }


  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    this.currentSort = event.direction ? event : null;
    this.applyFilters();
  }

  /**
  * Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
  * @param text Texto a normalizar
  */
  normalizeText(text: string): string {
    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }

  /**
   * Search Method
   */
  searchData(searchTerm: string): void {
    this.globalSearchTerm = searchTerm;
    this.applyFilters();
  }

  onColumnFilterChange(event: { column: string; value: string }): void {
    if (this.columnFilters[event.column] !== undefined) {
      this.columnFilters[event.column] = event.value;
      this.applyFilters();
    }
  }

  private initColumnFilters(): void {
    this.columnFilters = this.columns.reduce((filters, column) => {
      if (column.name !== 'accionesCasos') {
        filters[column.name] = '';
      }
      return filters;
    }, {} as { [key: string]: string });
  }

  private applyFilters(): void {
    const normalizedGlobalTerm = this.globalSearchTerm
      ? this.normalizeText(this.globalSearchTerm)
      : '';

    const activeColumnFilters = Object.entries(this.columnFilters)
      .map(([column, value]) => [column, value.trim()] as [string, string])
      .filter(([, value]) => value !== '');

    const filteredData = this.allDatasearch.filter((record) => {
      if (normalizedGlobalTerm && !this.matchesGlobalSearch(record, normalizedGlobalTerm)) {
        return false;
      }

      for (const [column, value] of activeColumnFilters) {
        const normalizedValue = this.normalizeText(value);
        if (!this.matchesColumnFilter(record, column, normalizedValue)) {
          return false;
        }
      }

      return true;
    });

    this.filteredRecords = filteredData;
    this.records = this.applySort(filteredData);
  }

  private applySort(records: Caso[]): Caso[] {
    if (!this.currentSort || this.currentSort.direction === '') {
      return [...records];
    }

    const { column, direction } = this.currentSort;
    const isAscending = direction === 'asc';

    return [...records].sort((a, b) => {
      const res = this.compare(a[column] as string | number, b[column] as string | number, isAscending);
      return isAscending ? res : -res;
    });
  }

  private matchesGlobalSearch(record: Caso, normalizedTerm: string): boolean {
    const values = [
      record.numero_expediente ?? '',
      record.estado ? record.estado.replace(/_/g, ' ') : '',
      formatDateString(record.fecha_solicitud ?? '', this.currentLanguage),
      this.getTribunalText(record),
      record.ultimoHitoDescripcion ?? '',
      formatDateStringWithTime(record.ultimoHitoFechaFin ?? '', this.currentLanguage)
    ];

    return values.some((value) => this.normalizeText(String(value)).includes(normalizedTerm));
  }

  private matchesColumnFilter(record: Caso, column: string, normalizedTerm: string): boolean {
    const value = this.getColumnSearchValue(record, column);
    return this.normalizeText(value).includes(normalizedTerm);
  }

  private getColumnSearchValue(record: Caso, column: string): string {
    switch (column) {
      case 'numero_expediente':
        return record.numero_expediente ?? '';
      case 'estado':
        return record.estado ? record.estado.replace(/_/g, ' ') : '';
      case 'fecha_solicitud':
        return formatDateString(record.fecha_solicitud ?? '', this.currentLanguage);
      case 'tribunal':
        return this.getTribunalText(record);
      case 'ultimoHitoDescripcion':
        return [
          record.ultimoHitoDescripcion ?? '',
          formatDateStringWithTime(record.ultimoHitoFechaFin ?? '', this.currentLanguage)
        ].join(' ').trim();
      default:
        return record[column] ? String(record[column]) : '';
    }
  }

  private getTribunalText(record: Caso): string {
    const tribunal = (record as { [key: string]: any })['tribunal'];
    if (Array.isArray(tribunal)) {
      return tribunal
        .map((miembro) => `${miembro?.nombre ?? ''} ${miembro?.apellidos ?? ''}`.trim())
        .filter((value) => value !== '')
        .join(' ');
    }
    return tribunal ? String(tribunal) : '';
  }
}
